import { API, API_POST } from "../../../Config";

export const handleAddQuestion = (payload,q_id) => {
  const f = new FormData();

  f.append("que", payload.title);
  f.append("options", JSON.stringify(payload.options));
  
  if(q_id){
    f.append('q_id',q_id);
  }
  return API_POST(API.AddQuestions, f);
};